/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-plusplus */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Button, Form, Select } from '@roo/roo'
import Modal from '@roo/roo/Modal'
import { useTranslation } from '@sailor/i18n-web'
import { debounce } from 'lodash'
import { getBatchList, createBatch, updateBatch } from '@/common/api/batch'
import CommonTable from '@/components/CommonTable'
import TipText from '@/components/TipText'

const enum EEditMode {
  EDIT = 'edit',
  CREATE = 'create',
}
const Field = Form.field
const FISCAL_YEAR_RANGE = {
  MIN: 2024,
  MAX: 2029,
}

export default () => {
  const { t } = useTranslation()
  const [data, setData] = useState<any[]>([])
  const [batchModalVisible, setBatchModalVisible] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [submitting, setSubmitting] = useState<boolean>(false)
  const [editMode, setEditMode] = useState<EEditMode>(EEditMode.CREATE)
  const [pageNo, setPageNo] = useState<number>(1)
  const [pageSize, setPageSize] = useState<number>(10)
  const [total, setTotal] = useState<number>(0)
  const currentRecordRef = useRef<any>({})
  const formRef = useRef<any>(null)

  const rules = {
    batchName: [
      {
        required: true,
        message: t('batch_name_empty_validation', '请输入批次名称'),
      },
      {
        max: 200,
        message: t('batch_name_length_validation', '批次名称最多输入不可超过'),
      },
    ],
    fiscalYear: [
      {
        required: true,
        message: t('fiscal_year_empty_validation', '请输入财年'),
        trigger: 'onBlur',
      },
    ],
  }

  const fetchTableData = async () => {
    setLoading(true)
    const res = await getBatchList({ pageNo, pageSize })
    const { success, data } = res
    if (success) {
      const { result = [], totalCount = 0 } = data || {}
      setTotal(totalCount)
      setData(result)
    }
    setLoading(false)
  }
  useEffect(() => {
    fetchTableData()
  }, [pageNo, pageSize])

  const handlePageChange = (_pageNo: number, _pageSize: number) => {
    _pageNo !== pageNo && setPageNo(_pageNo)
    _pageSize !== pageSize && setPageSize(_pageSize)
  }

  const openBatchModal = ({ record, mode } :{record?: any, mode: EEditMode}) => {
    setEditMode(mode)
    const currentYear = new Date().getFullYear()
    currentRecordRef.current = record || { fiscalYear: String(currentYear) }
    setBatchModalVisible(true)
  }

  const columns: any = [
    { dataIndex: 'batchName', title: t('batch_name', '批次名称'), render: (value: string) => <TipText text={value} /> },
    { dataIndex: 'batchNo', title: t('batch_no', '批次编号'), width: 220 },
    { dataIndex: 'fiscalYear', title: t('fiscal_year', '财年'), width: 100 },
    {
      title: t('batch_common_operation', '操作'),
      width: 150,
      fixed: 'right',
      align: 'center',
      render: (_: never, record: any) => (
        <Button
          type="brand-text"
          onClick={() => {
            openBatchModal({ record, mode: EEditMode.EDIT })
          }}
        >
          {t('batch_common_edit', '编辑')}
        </Button>
      ),
    },
  ]

  const handleFormSubmit = async (
    value: { batchName: string; batchNo?: string, fiscalYear: string },
    errors: any[] | null
  ) => {
    if (errors && errors.length > 0) {
      return
    }
    const { batchName, ...rest } = value
    const parsedBatchName = batchName?.trim() ?? ''
    // 未修改点击确定时不请求直接关闭弹窗
    if (JSON.stringify(currentRecordRef.current) === JSON.stringify(value)) {
      setBatchModalVisible(false)
      return
    }
    setSubmitting(true)
    const requestInstance = editMode === EEditMode.CREATE ? createBatch : updateBatch
    const params = { ...rest, batchName: parsedBatchName }
    const res = await requestInstance(params)
    setSubmitting(false)
    if (res?.success) {
      setBatchModalVisible(false)
      fetchTableData()
    }
  }

  const debounceHandleFormSubmit = debounce(handleFormSubmit, 200)

  const getFiscalYearOptions = (): {label: string, value: string}[] => {
    const options = []
    for (let i = FISCAL_YEAR_RANGE.MIN; i <= FISCAL_YEAR_RANGE.MAX; i++) {
      const cur = String(i)
      options.push({ label: cur, value: cur })
    }
    return options
  }

  return (
    <div className="page-content" style={{ display: 'flex', flexDirection: 'column' }}>
      <div className="page-title">
        {t('batch_management', '批次管理')}
      </div>
      <div style={{ display: 'flex', justifyContent: 'end', marginTop: '24px' }}>
        <Button type="brand" onClick={() => openBatchModal({ mode: EEditMode.CREATE })} >
          {t('create_batch', '创建批次')}
        </Button>
      </div>
      <CommonTable
        rowKey="batchNo"
        loading={loading}
        columns={columns}
        data={data}
        pagination={{
          total,
          pageSize: pageSize,
          onChange: handlePageChange,
        }}
      />
      <Modal
        title={editMode === EEditMode.EDIT ? t('edit_batch', '修改批次') : t('create_batch', '创建批次')}
        size="lg"
        visible={batchModalVisible}
        closeMotion={false}
        onCancel={() => {
          setBatchModalVisible(false)
        }}
        onConfirm={() => {
          if (formRef.current && formRef.current.handleSubmit) {
            formRef.current.handleSubmit()
          }
        }}
        confirmButtonProps={{ loading: submitting, style: { fontWeight: 500 } }}
        showCancelButton={false}
        cancelText={t('e_pc_cancel_button', 'Cancel')}
        confirmText={t('e_pc_confirm_button', 'Confirm')}
      >
        <Form
          value={currentRecordRef.current}
          colon
          onSubmit={debounceHandleFormSubmit}
          cols={{ label: { span: 3 }, field: { span: 8 } }}
          ref={formRef}
          rules={rules}
        >
          {() => (
            <form>
              <Field
                label={t('batch_name', '批次名称')}
                name="batchName"
                placeholder={t('batch_name_empty_validation', '请输入批次名称')}
              />
              <Field
                label={t('fiscal_year', '财年')}
                name="fiscalYear"
                as={(
                  <Select
                    options={getFiscalYearOptions()}
                  />
                )}
              />
              {editMode === EEditMode.EDIT ? (
                <Field
                  label={t('batch_no', '批次编号')}
                  name="batchNo"
                  placeholder={t('batch_no_empty_validation', '请输入批次编号')}
                  disabled
                />
              ) : null}
            </form>
          )}
        </Form>
      </Modal>
    </div>
  )
}
